// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkbenchRouteImport } from './routes/_workbench'
import { Route as IndexRouteImport } from './routes/index'
import { Route as A2uiGalleryExamplesRouteImport } from './routes/a2ui-gallery.examples'
import { Route as A2uiGalleryComponentsRouteImport } from './routes/a2ui-gallery.components'
import { Route as WorkbenchChatRouteImport } from './routes/_workbench.chat'
import { Route as WorkbenchA2uiPreviewRouteImport } from './routes/_workbench.a2ui-preview'
import { Route as WorkbenchA2uiGalleryRouteImport } from './routes/_workbench.a2ui-gallery'
import { Route as WorkbenchA2uiExamplesRouteImport } from './routes/_workbench.a2ui-examples'
import { Route as WorkbenchA2uiGalleryExampleIdRouteImport } from './routes/_workbench.a2ui-gallery_.$exampleId'
import { Route as WorkbenchA2uiPreviewImportedImportKeyRouteImport } from './routes/_workbench.a2ui-preview.imported.$importKey'

const WorkbenchRoute = WorkbenchRouteImport.update({
            id: '/_workbench',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const A2uiGalleryExamplesRoute = A2uiGalleryExamplesRouteImport.update({
            id: '/a2ui-gallery/examples',path: '/a2ui-gallery/examples',getParentRoute: () => rootRouteImport
          })
const A2uiGalleryComponentsRoute = A2uiGalleryComponentsRouteImport.update({
            id: '/a2ui-gallery/components',path: '/a2ui-gallery/components',getParentRoute: () => rootRouteImport
          })
const WorkbenchChatRoute = WorkbenchChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => WorkbenchRoute
          })
const WorkbenchA2uiPreviewRoute = WorkbenchA2uiPreviewRouteImport.update({
            id: '/a2ui-preview',path: '/a2ui-preview',getParentRoute: () => WorkbenchRoute
          })
const WorkbenchA2uiGalleryRoute = WorkbenchA2uiGalleryRouteImport.update({
            id: '/a2ui-gallery',path: '/a2ui-gallery',getParentRoute: () => WorkbenchRoute
          })
const WorkbenchA2uiExamplesRoute = WorkbenchA2uiExamplesRouteImport.update({
            id: '/a2ui-examples',path: '/a2ui-examples',getParentRoute: () => WorkbenchRoute
          })
const WorkbenchA2uiGalleryExampleIdRoute = WorkbenchA2uiGalleryExampleIdRouteImport.update({
            id: '/a2ui-gallery_/$exampleId',path: '/a2ui-gallery/$exampleId',getParentRoute: () => WorkbenchRoute
          })
const WorkbenchA2uiPreviewImportedImportKeyRoute = WorkbenchA2uiPreviewImportedImportKeyRouteImport.update({
            id: '/imported/$importKey',path: '/imported/$importKey',getParentRoute: () => WorkbenchA2uiPreviewRoute
          })





const WorkbenchA2uiPreviewRouteChildren = {
  WorkbenchA2uiPreviewImportedImportKeyRoute: WorkbenchA2uiPreviewImportedImportKeyRoute
}

const WorkbenchA2uiPreviewRouteWithChildren = WorkbenchA2uiPreviewRoute._addFileChildren(WorkbenchA2uiPreviewRouteChildren)



const WorkbenchRouteChildren = {
  WorkbenchA2uiExamplesRoute: WorkbenchA2uiExamplesRoute,WorkbenchA2uiGalleryRoute: WorkbenchA2uiGalleryRoute,WorkbenchA2uiPreviewRoute: WorkbenchA2uiPreviewRouteWithChildren,WorkbenchChatRoute: WorkbenchChatRoute,WorkbenchA2uiGalleryExampleIdRoute: WorkbenchA2uiGalleryExampleIdRoute
}

const WorkbenchRouteWithChildren = WorkbenchRoute._addFileChildren(WorkbenchRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,WorkbenchRoute: WorkbenchRouteWithChildren,A2uiGalleryComponentsRoute: A2uiGalleryComponentsRoute,A2uiGalleryExamplesRoute: A2uiGalleryExamplesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)